<template>
  <p class="list-foot" style="font-size: 14px;"><slot>到底了~</slot></p>
</template>

<script>
  export default {
    name: "list-foot"
  }
</script>

<style lang="less" scoped>
.list-foot {
  text-align: center;
  color: #676767;
  padding: 12px 0 32px 0;
}
</style>